import { EvtHeader } from "components/header";
import React from "react";
import { useProject } from "@/modules/work/projects/context";
import Loader from "@/components/loader";
import ContractForm from "@/modules/work/contracts/form";

const CreateContract = () => {
  const { data, isLoading } = useProject();

  if (isLoading) return <Loader />;

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Contract" />
      <div className="p-6 max-w-2xl">
        <ContractForm defaultProjectId={data.id} />
      </div>
    </div>
  );
};

export default CreateContract;
